import { PageContainer } from '../../shared/PageContainer';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Box, useTheme } from '@mui/material';
import { PageDefaultSegment } from '@sis/react-library';

export const FormSamplesAboutPage = () => {

  const theme = useTheme();

  return (
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    // Every page must be wrapped in a PageDefaultContainer
    // The PageContainer component below wraps the PageDefaultContainer and also
    // sets the title for each page
    // If you don't want to show a header add the noHeader prop to PageContainer 
    // (which will pass it to PageDefaultContainer)
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    <PageContainer heading='Form Samples - About' icon={<TextSnippetIcon />} >
      <PageDefaultSegment
        //background='blue' 
        //color='white'  // You can change the background colour and font colour
      >
        <h3>Context</h3>

        The Forms component is reliant on the FormProvider context.<br />
        The SisLibraryProviders context includes the FormProvider context so make sure your main app is wrapped in this context.
        <br />(usually in the index.tsx file)<br /><br />
        <Box sx={{ background: theme.palette.action.selected }}>
          <code>
            &nbsp;&nbsp;{"<SisLibraryProviders>"}<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{"<App>"}<br />
            &nbsp;&nbsp;{"</SisLibraryProviders>"}<br />
          </code>
        </Box>
        <br />
        The SisLibraryProviders includes all providers for this library, which is the FormsProvider, the AlertsProvider and the FeedbackProvider.

        <h3>Advantages</h3>
        <ul>
          <li>Keeping state of the values within the form is handled in the Form components, removing any boilder plate state code you might impliment to keep track of every field value.</li>
          <li>As the state is kept within the Form component, there is also no need for boilder plate code setting the value and onChange on every control.</li>
          <li>The form accepts an interface, meaning that every field that a property is linked to has no spelling errors.</li>
        </ul>
        The code for these samples can be found in <i>'src/components/formSamples/formSamplesPages/'</i>.
        <br /><br />
        <h3>Prompting when navigating away after changes are made</h3>
        When changes are made to a form and navigating away, if you add a message to the prop <i>beforeLeaveText</i> the user will be prompted that changes were made
        and if they wish to proceed. There are 2 types of navigating away.
        <ol>
          <li>From the browser: (refreshing the page, typing in a new URL, etc)</li>
          <li>From the router-dom component: (clicking on a navigation link, using forward and back in the browser)</li>
        </ol>
      </PageDefaultSegment>
    </PageContainer>
  )
}
